/*
 * e.g.
 * 默认样式：<button>查看更多</button>
 * 浅色:<button class="light">查看更多</button>
 */

import Button from './button'

export default Button
